const Portals = () => (
  <>
    <div id="popper-portal" />
    <div id="modal-portal" />
  </>
);

export default Portals;
